import { render, staticRenderFns } from "./StudentIdentityModal.vue?vue&type=template&id=22ed07c6&"
import script from "./StudentIdentityModal.vue?vue&type=script&lang=js&"
export * from "./StudentIdentityModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports